export var ElementIntent;
(function (ElementIntent) {
    ElementIntent["Info"] = "info";
    ElementIntent["Success"] = "success";
    ElementIntent["Warning"] = "warning";
    ElementIntent["Danger"] = "danger";
})(ElementIntent || (ElementIntent = {}));
